/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import * as dataAPIUtil from 'utils/api/data';
import { setOutOfContent } from 'redux/actions/embed_status';
import { updateContentStatus } from 'redux/actions/content_status';
import { batchActions } from 'redux-batched-actions';
// For publisher portal preview import mixed content data created by the publisher portal
import { mxQuestionData, pqQuestionData } from 'config/config';
import { showFentchingScreen, removeFetchingScreen } from "utils/fetchingscreencontrol";
import {setTotalFrameCount, setUniqueState} from "./content_status";


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const RECEIVE_ERRORS = 'RECEIVE_ERRORS';
export const RECEIVE_CONTENTS_DATA = 'RECEIVE_CONTENTS_DATA';
export const TRIGGER_FETCH = 'TRIGGER_FETCH';
export const STORE_DATA = 'STORE_DATA';
export const RECEIVE_QUESTIONNAIRE_DATA = 'RECEIVE_QUESTIONNAIRE_DATA';
export const CLEAR_CONTENTS_DATA = 'CLEAR_CONTENTS_DATA';

export const triggerFetch = contentIds => ({
    type: TRIGGER_FETCH,
    contentIds
});
export const receiveContentsData = data => ({
    type: RECEIVE_CONTENTS_DATA,
    data
});
export const receiveQuestionnaireData = (contentId, data) => ({
   type: RECEIVE_QUESTIONNAIRE_DATA,
    contentId,
    data
});
export const receiveErrors = errors => ({
    type: RECEIVE_ERRORS,
    errors
});
export const storeData = (contentId, propertyName, data) => ({
    type: STORE_DATA,
    contentId,
    propertyName,
    data
});
export const clearContentsData = contentIds => ({
    type: CLEAR_CONTENTS_DATA,
    contentIds
});

const processContentData = (contentId, data, isPubPortalPreview) => dispatch => (
    dispatch(batchActions([
        receiveContentsData(data),
        removeFetchingScreen(),
        updateContentStatus(contentId, data, false),
        setOutOfContent(!isPubPortalPreview && data.length > 0 ? false : null)
    ]))
);

const processQuestionnaireData = (contentId, data, isPubPortalPreview) => dispatch => (
    dispatch(batchActions([
        receiveQuestionnaireData(contentId, data),
        removeFetchingScreen(),
        updateContentStatus(contentId, data, true),
        setOutOfContent(!isPubPortalPreview && data.length > 0 ? false : null)
    ]))
);

export const fetchContentsData = (embedUUID, contentId, cookieId, contentOrder, numberOfQuestionsLimit, isPubPortalPreview) => dispatch => {
    // For publisher portal process data set on the window by pub portal
    if (isPubPortalPreview) return dispatch(processContentData(contentId, mxQuestionData, isPubPortalPreview));
    dispatch(showFentchingScreen(contentId));
    return dataAPIUtil.fetchContentsData(embedUUID, cookieId, contentOrder, numberOfQuestionsLimit)
        .then(data => dispatch(processContentData(contentId, data, isPubPortalPreview)),
            () => dispatch(processContentData(contentId, [], isPubPortalPreview)))
};

export const fetchQuestionnaireData = (questionnaireContentId, cookieId, uniqueueProps, isPubPortalPreview) => dispatch => {
    if (isPubPortalPreview) return dispatch(processQuestionnaireData(questionnaireContentId, pqQuestionData, isPubPortalPreview));
    dispatch(showFentchingScreen(questionnaireContentId));
    return dataAPIUtil.fetchQuestionnaireData(cookieId, uniqueueProps)
        .then(data => dispatch(processQuestionnaireData(questionnaireContentId, data, isPubPortalPreview)),
            () => dispatch(processQuestionnaireData(questionnaireContentId, [], isPubPortalPreview)))
};
